import { TextFilterProps } from '@progress/kendo-react-data-tools'

import { ClientSubscriptionType } from '../../api/Clients/Types/ClientSubscriptionType'
import { SelectFilter } from '../Filter/SelectFilter'

export const SelectSubscriptionTypeFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props

  const data = ClientSubscriptionType.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}
